import { createAction } from 'redux-actions';
import * as constants from 'constants/redux/cottages';

export const fetchCottagesRequest = createAction(constants.FETCH_COTTAGES_REQUEST);
export const fetchCottagesSuccess = createAction(constants.FETCH_COTTAGES_SUCCESS);
export const fetchCottagesFailure = createAction(constants.FETCH_COTTAGES_FAILURE);

export const fetchStatsRequest = createAction(constants.FETCH_STATS_REQUEST);
export const fetchStatsSuccess = createAction(constants.FETCH_STATS_SUCCESS);
export const fetchStatsFailure = createAction(constants.FETCH_STATS_FAILURE);

export const updateCottagesData = createAction(constants.UPDATE_COTTAGES_DATA);

export const fetchCottagesTagsRequest = createAction(constants.FETCH_COTTAGES_TAGS_REQUEST);
export const fetchCottagesTagsSuccess = createAction(constants.FETCH_COTTAGES_TAGS_SUCCESS);
